export const setNodeDetail = (context, payload) => {
    context.commit("setDetail",  payload)
}

export const setFavorites = (context, payload) => {
    context.commit("setFavorites",  payload)
}
